"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavIconLinks = void 0;
const react_1 = __importDefault(require("react"));
const webapp_constants_1 = require("@eventbrite/webapp-constants");
const DevIconLinks_1 = require("./DevIconLinks");
const ProdIconLinks_1 = require("./ProdIconLinks");
const QaIconLinks_1 = require("./QaIconLinks");
const FavIconLinks = ({ stage = webapp_constants_1.Stage.PROD }) => {
    let FavIconLinks = ProdIconLinks_1.ProdIconLinks;
    if (stage === webapp_constants_1.Stage.DEV) {
        FavIconLinks = DevIconLinks_1.DevIconLinks;
    }
    else if (stage === webapp_constants_1.Stage.TEST) {
        FavIconLinks = QaIconLinks_1.QaIconLinks;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FavIconLinks, null),
        react_1.default.createElement("link", { rel: "apple-touch-icon", href: "https://cdn.evbstatic.com/s3-build/perm_001/8730ae/django/images/touch_icons/apple-touch-icon-180x180.png" }),
        react_1.default.createElement("link", { rel: "manifest", href: "https://cdn.evbstatic.com/s3-build/perm_001/befbf7/django/images/favicons/manifest.webmanifest" })));
};
exports.FavIconLinks = FavIconLinks;
//# sourceMappingURL=FavIconLinks.js.map